
import useVoiceChatbot from './hooks/useVoiceChatbot';
import PlayStopButton from './components/PlayStopButton';

function SpeechBot() {
    const cssContent = require('./SpeechBot.css').toString();
    const {
        isListening,
        isAISpeaking,
        isConnected,
        streamingActive,
        startConversation,
        stopConversation,
        webChatSettings
    } = useVoiceChatbot();

    // No renderizar si no tenemos las configuraciones
    if (!webChatSettings) {
        return (
            <div className="speechbot-container">
                <div>Voice chat not available</div>
            </div>
        );
    }

  return (
    <div className="speechbot-container">
      <style>
        {cssContent}
      </style> 
      <PlayStopButton
        isActive={isListening}
        isConnected={isConnected}
        isAISpeaking={isAISpeaking}
        streamingActive={streamingActive}
        onStart={startConversation}
        onStop={stopConversation}
      />
    </div>
  );
}

export default SpeechBot;